export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    products: function products() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'products',
        method: 'get',
        data: data
      });
    },
    environments: function environments() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'environments',
        method: 'get',
        data: data
      });
    },
    environmentsCreate: function environmentsCreate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'environments/create',
        method: 'post',
        data: data
      });
    },
    environmentsUpdate: function environmentsUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'environments/update',
        method: 'post',
        data: data
      });
    },
    environmentsDelete: function environmentsDelete() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'environments/delete',
        method: 'post',
        data: data
      });
    },
    productsCreate: function productsCreate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'products/create',
        method: 'post',
        data: data
      });
    },
    productsUpdate: function productsUpdate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'products/update',
        method: 'post',
        data: data
      });
    },
    productsDelete: function productsDelete() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: 'products/delete',
        method: 'post',
        data: data
      });
    }
  };
});